export default __webpack_public_path__ + "static/work-remotely-555ce605bea2e40e2dd4e7039a45ea73.webp";